import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import styles from "./AddDeleteImageModal.module.scss";
import {ReactComponent as UploadImageIcon} from "../../../../../../../../assets/promos&items/upload_image_icon.svg";
import {ReactComponent as DeleteImageIcon} from "../../../../../../../../assets/promos&items/delete_image_icon.svg";
import {AsyncImageWithLoader} from "../../../../../../../../com/imageWithLoader/imageWithLoader";
import {FileInput} from "../../../../../../../com/FileInput/FileInput";
import {useDispatch} from "react-redux";
import {
    deleteImageFromItems,
    uploadImageToItem
} from "../../../../../../../../store/actionCreators/promotionsItemsCreators";
import {useTypedSelector} from "../../../../../../../../hooks/useTypeSelector";
import {PromoItemsDto} from "../../../../../../../../dtos";
import {PageSpinner} from "../../../../../../../com/pagesTab/pagesSpinner/spinner";
import {ReactComponent as ImageWithError} from "../../../../../../../../assets/promos&items/image_error.svg";
import {ClosePopupBtn} from "../../../../../../../../com/closePopupBtn/closePopupBtn";


interface Props {
    isShow: boolean;
    setOpenImageModal: (value: boolean) => void;
    src: string;
    caption: string;
    item: PromoItemsDto;
    setItemState: (item: PromoItemsDto) => void;
}


export const AddDeleteImageModal: React.FC<Props> = (
    {
        isShow,
        setOpenImageModal,
        src,
        caption,
        item,
        setItemState
    }
) => {

    const dispatch = useDispatch();
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);

    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);

    const [selectedImageFile, setImageFile] = useState<File | null>();
    const [isLoading, setLoadingWrapper] = useState<boolean>(false);
    const [fileName, setFileName] = useState<string | undefined>('');

    useEffect(() => {
        const text = src.split("/").pop();
        setFileName(text);
    }, [src])


    useEffect(() => {
        setLoadingWrapper(promotionsItemsState.isLoading);
        if (promotionsItemsState.type === "POST_IMAGE_TO_ITEM_SUCCESS" || promotionsItemsState.type === "DELETE_IMAGE_FROM_ITEM_SUCCESS") {
            if (selectedImageFile) {
                let newSrc = URL.createObjectURL(selectedImageFile);
                setItemState({
                    ...item,
                    fpiImage: newSrc
                })
            } else {
                setItemState({
                    ...item,
                    fpiImage: ''
                })
            }

        }
    }, [promotionsItemsState.type])

    useEffect(() => {
        setLoadingWrapper(flippingFlyerState.loading);
    }, [flippingFlyerState.type])

    const onFileSelected = (file: File) => {
        setImageFile(file);
        dispatch(uploadImageToItem(flyerDetailsState.flyRecId, file, flyerDetailsState.flyLacRec!.lacCode!, item.fpiRecId ? item.fpiRecId : null));
    }

    const deleteImage = () => {
        setImageFile(null);
        dispatch(deleteImageFromItems([item.fpiRecId!], flyerDetailsState.flyLacRec!.lacCode!));
    }

    return (
        <Modal dialogClassName={styles.add_delete_image_modal} show={isShow}>
            <div className={styles.header_modal}>
                <div className={styles.header_caption} title={caption}>
                    Lead image: {caption}
                </div>
                <ClosePopupBtn onClose={() => setOpenImageModal(false)}/>
            </div>
            <div className={styles.content_modal}>
                <div className={styles.image_wrapper}>
                    <AsyncImageWithLoader src={src} notUploadIcon={(<ImageWithError/>)}/>
                </div>
            </div>
            <div className={styles.footer_modal}>
                <div className={styles.upload_icon_wrapper}>
                    <FileInput
                        onFileSelected={onFileSelected}
                        icon={(
                            <UploadImageIcon/>
                        )}
                        validFileExtensions={`.jpg,.jpeg,.png`}
                        isMultipleSelection={false}
                    />
                </div>
                <div className={styles.image_file_name}>
                    {fileName}
                </div>
                <div className={styles.delete_icon_wrapper} onClick={deleteImage}>
                    <DeleteImageIcon/>
                </div>
            </div>
            {
                isLoading && <div className={styles.isLoading}>
                    <PageSpinner/>
                </div>
            }
        </Modal>

    )
}